import { Heading, Stack, useToast } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  addNewPanelsToUserLab,
  useLabs,
  userLabsStore,
  useUserLab,
} from '../../../data/labsCollection'
import CenteredSpinner from '../../../components/CenteredSpinner'
import NotFound from '../../NotFound'
import useActiveUid from '../../../hooks/useActiveUid'
import { Lab, UserLab } from '../../../types/bloodWork'
import UserLabTable from '../../../components/BloodWork/UserLabTable'
import ScrollToTop from '../../../components/ScrollToTop'
import { useEffect, useState } from 'react'

export default () => {
  // debugger;
  const { userLabId } = useParams()
  const navigate = useNavigate()
  const toast = useToast()
  const [userLab, setUserLab] = useState<UserLab>()
  const [lab, setLab] = useState<Lab>()

  const userId = useActiveUid()

  const [userLabSnapshot, labFound] = useUserLab({
    userLabId: userLabId ?? '',
    userId: userId,
  })

  let userLabData = userLabSnapshot?.data()

  const [labSnapshot] = useLabs({
    title: userLabData?.title ?? '',
    isArchived: false,
  })

  useEffect(() => {
    if (!lab && labSnapshot && labSnapshot.length === 1) {
      setLab(labSnapshot[0].data())
    }
  }, [lab, labSnapshot])

  useEffect(() => {
    if (lab && !userLab && userLabData) {
      setUserLab(addNewPanelsToUserLab(lab, userLabData))
    }
  }, [lab, userLab, userLabData])

  let archiveFunc = undefined
  let submitButtonText = 'Restore'
  let submitButtonColorScheme = 'green'
  let readOnly = true
  let onSubmit = async (userLab: UserLab) => {
    if (userLabId) {
      await userLabsStore.unarchive(userLabId)
      setUserLab(undefined)
      toast({ status: 'success', description: 'Lab Restored!' })
    } else {
      toast({
        status: 'error',
        description: 'Lab not found. Please contact support.',
      })
    }
  }
  let cancelFunc = () => {
    navigate('/labs/archived')
  }

  if (!userLab?.archived) {
    submitButtonText = 'Update'
    submitButtonColorScheme = 'purple'
    readOnly = false
    onSubmit = async (userLab: UserLab) => {
      if (userLabId) {
        await userLabsStore.update(userLabId, userLab)
        toast({ status: 'success', description: 'Lab updated!' })
      } else {
        toast({
          status: 'error',
          description: 'Lab not found. Please contact support.',
        })
      }
    }

    cancelFunc = () => {
      navigate('/labs')
    }

    archiveFunc = async () => {
      if (window.confirm('Archive this lab? You may restore it at anytime.')) {
        //setting the navigation first
        //when setting after archive, the userLab becomes "<NotFound />"
        //before the navigation takes place
        if (userLabId) {
          navigate('/labs')
          await userLabsStore.archive(userLabId)
        } else {
          toast({
            status: 'error',
            description: 'Lab not found. Please contact support.',
          })
        }
      }
    }
  }

  if (labFound === false) {
    return <NotFound />
  }

  if (!userLab) {
    return <CenteredSpinner />
  }

  return (
    userLab && (
      <Stack spacing={5}>
        <ScrollToTop />
        <Heading>Edit {userLab.title} Lab Test</Heading>
        <UserLabTable
          userLab={userLab}
          setUserLab={setUserLab}
          onSubmitFunc={onSubmit}
          submitButtonText={submitButtonText}
          submitButtonColorScheme={submitButtonColorScheme}
          cancelFunc={cancelFunc}
          archiveFunc={archiveFunc}
          readOnly={readOnly}
        />
      </Stack>
    )
  )
}
